import React from 'react';
import { connect } from 'react-redux';

// Components
import { FormFieldText } from 'components/lib/FormFields';
import Button from 'components/lib/Button';
import FlexBar from 'components/lib/FlexBar';

import formCreator from 'features/components/formCreator';
import { fieldProps } from 'features/components/formCreator';

// Utils
import * as commons from 'utils/UtilityStore/actions';

export class VistaIntegration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
    };
    this.toggleHidden = this.toggleHidden.bind(this);
    this.saveAndSubmit = this.saveAndSubmit.bind(this);
  }

  toggleHidden() {
    const { isEditing } = this.state;
    this.setState({
      isEditing: !isEditing,
    });
  }

  componentDidMount() {
    this.props.createRequest(this.createRequest.bind(this));
  }

  saveAndSubmit() {
    this.props.submitForm();
    return this.toggleHidden();
  }

  render() {
    const { formIsWorking, formIsReady } = this.props;
    const { isEditing } = this.state;

    return (
      <div>
        <FlexBar>
          <FlexBar.Child isGrow>
            <FormFieldText {...fieldProps(this.props, 'vista_url')} label="URL" isDisabled={!isEditing} isHorizontal isFullWidth isFlat placeholder="exemplo1234-rest.vistahost.com.br" />
          </FlexBar.Child>
          <FlexBar.Child isGrow>
            <FormFieldText {...fieldProps(this.props, 'vista_key')} label="Key" isDisabled={!isEditing} isHorizontal isFullWidth isFlat />
          </FlexBar.Child>
          <FlexBar.Child>
            {!isEditing ? (
              <Button hasThemeColor onClick={this.toggleHidden} isHorizontal isFlat>
                Editar
              </Button>
            ) : (
              <Button hasThemeColor isLoading={formIsWorking} onClick={this.saveAndSubmit} isDisabled={formIsWorking} isHorizontal isFlat>
                Salvar
              </Button>
            )}
          </FlexBar.Child>
        </FlexBar>
      </div>
    );
  }

  createRequest(fields) {
    this.props.submit('{company}/settings', fields, 'put');
  }
}

export default connect((store) => ({}), { ...commons })(formCreator(VistaIntegration));
